import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFinalCTA from "../../components/feature/InfoPageFinalCTA";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import ScheduleSection from "./components/ScheduleSection";
import TipsSection from "./components/TipsSection";
import { useFlowData } from "../../lib/useMockData";

export default function Flow() {
  const { heroData, finalCTA } = useFlowData();
  return (
    <PageLayout>
      <InfoPageHero
        label="DAY OF FLIGHT"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="当日の流れ"
      />
      <ScheduleSection />
      <TipsSection />
      <InfoPageFinalCTA
        title={finalCTA.title}
        subtitle={finalCTA.subtitle}
        ctas={finalCTA.ctas}
      />
      <InfoPageFooter />
    </PageLayout>
  );
}
